import cx from 'classnames'
import React from 'react'
import { MdOutlineCheckBox } from 'react-icons/md'
import { useSlate } from 'slate-react'

import { insertInlineCheckbox, isBlockTypeActive, isInlineCheckboxFeasible } from '../util'

export function InlineCheckboxButton ({ label = 'Inline checkbox' }) {
  const editor = useSlate()
  const isActive = isBlockTypeActive(editor, 'checkbox')
  const isFeasible = isInlineCheckboxFeasible(editor)
  const title = [ label, isActive && '(active)' ].filter(Boolean).join(' ')

  return (
    <button
      type='button'
      className={cx('rounded-sm transition-colors flex flex-row gap-3 w-full disabled:text-[#aaaaaa] disabled:cursor-not-allowed', [
        isActive ? 'text-primary' : 'text-[#9CA3AF]'
      ])}
      onMouseDown={event => {
        event.preventDefault()
        insertInlineCheckbox(editor)
      }}
      disabled={!isFeasible}
      title={title}
    >
      <MdOutlineCheckBox size='1.2rem' />
    </button>
  )
}
